/* jslint laxbreak:true */

(function (sculpteo) {
  "use strict";

  var PrintController = sculpteo.PrintController;
  var PrintController2D = (sculpteo.PrintController2D = function (
    design,
    materials,
    listOfUrls,
    options
  ) {
    this.texts = [
      [gettext("Material"), gettext("Select your material"), "process"],
      [gettext("Colors"), gettext("Select your color"), "material"],
      [gettext("Thickness"), gettext("Select your thicknesss"), "thickness"],
    ];
    this.controllerType = "2D";

    PrintController.call(this, design, materials, listOfUrls, options);

    this.options = options;
    this.views.viewer = new sculpteo.PrintViewer2DView(this, design);
    this.views.toolbar = new sculpteo.PrintToolbar2DView(this, this.design);
    this.views.productionCenter = new sculpteo.PrintModalProductionCenterView(
      this,
      this.design
    );
    this.views.review2D = new sculpteo.PrintReview2DView(this, this.design);
    this.views.previewMaterial = new sculpteo.PrintPreviewMaterialView(
      this,
      this.design
    );

    //use for checking error
    //we need this because of our way to deal with error and our notification view
    //we clear the notification after every price request
    //but in 2D we need to keep to error even after getting a new price
    this.hasHiddenCut = false;

    //same here with issues
    this.hasIssuesWithClosedPath = false;

    //same with config
    this.hasNoConfiguration = false;

    //update the design.order.production_center based on the user settings
    //add the current production center to a variable
    this.currentProductionCenter =
      this.views.productionCenter.initProductionCenter();
    // update default material list
    this.updateDefaultMaterialMapBasedCatalogAndCurrency();

    this.design
      .fetch_operation(true, false, "x_design_detail_operations_3D")
      .then(
        function () {
          SvgViewer.on_viewer_initialized = this.onViewerInitialized.bind(this);
          SvgViewer.on_save_legend = this.updateConfiguration.bind(this);
          SvgViewer.on_allowed_changed = this.onAllowedChanged.bind(this);
          SvgViewer.on_save_legend_error = this.onSaveLegendError.bind(this);
          SvgViewer.on_legend_change = this.onLegendChange.bind(this);

          // In case of design with US material by default.
          // we need to force the update of the production center
          this.updateProductionCenter(this.currentProductionCenter);

          this.updateMaterialList().then(
            function () {
              this.views.settings.materialChanged(null, 1);
            }.bind(this)
          );

          var dfd = true;
          var clean_op = this.design.get_operation(
            "LasercutCleanPathsDesignOperation"
          );

          if (clean_op && clean_op.data.enabled) {
            dfd = clean_op.modify({ enabled: false });
            laser_url = this.design.model_url();
          }
          $.when(dfd).then(
            function () {
              SvgViewer.updateScale(
                this.design.size.scaleFactor(),
                0,
                this.design.size.unit,
                this.design.size.units
              );
              SvgViewer.load_svg_file(laser_url, false);
            }.bind(this)
          );
        }.bind(this)
      );
  });

  PrintController2D.prototype = Object.create(PrintController.prototype);

  /**
   * handles loading. Hide/show price and setting
   *
   * @public
   * boolean
   */
  PrintController2D.prototype.setLoading = function (status, message) {
    this.views.price.enabled(!status);
    this.views.settings.enabled(!status);
  };

  PrintController2D.prototype.updateDefaultMaterialMapBasedCatalogAndCurrency =
    function () {
      this.materials.setDefaultMaterialMap();
    };

  PrintController.prototype.updatePriceForSelectedMaterial = function () {
    var deferred = $.Deferred();
    //if the model is NOT orderable we do not update the price
    if (this.design.is_orderable == false) {
      return deferred;
    }

    this.setLoading(true);

    //show overlay message
    this.overlayNotify(
      sculpteo.PrintOverlayNotification.TYPE.UPDATE,
      gettext("Updating prices and delays"),
      false
    );

    this.materials
      .computePricesAndDelays(true)
      .done(
        function () {
          var priceData = this.materials.getPricesForMaterial(
            this.design.material
          );
          //we set error/warnings to null before to check for error/warnings
          this.error = null;
          this.warnings = null;

          // clears all notification notifications
          this.views.notification.clear();

          //if priceData get error we set this.error with this error (id, text and data)
          //and call nofitication to show the error
          //same with the warning except that it might have 1 or more, so we need a list

          //priceData.error is the old way to get the error
          //priceData.error_info is the new way with the new print page
          //it hold more infos like an ID, the text and data if there is data
          if (
            priceData.delivery !== undefined &&
            (priceData.delivery.nb_printers == "-1" ||
              priceData.delivery.nb_printers == "n/a")
          ) {
            priceData.error =
              gettext("No printer available for this material") +
              ":<br>" +
              this.design.material.name +
              ". " +
              gettext("Changing the Production Center might help.");
            //simulate how the error works in gallery/models.py  line:3256
            priceData.error_info = {
              ID: "no_printer_available",
              data: priceData.error,
              text: "",
            };
          }

          //check for error
          //not the best way to handle errors but most of it are generated by PrintLaserCutLegend.js
          if (this.hasNoConfiguration) {
            priceData.error_info = {
              ID: "lasercut_all_ignored",
              data: "",
              text: "",
            };
          }

          if (priceData.error) {
            this.error = priceData.error_info;
            this.notify(
              "error",
              priceData.error_info.ID,
              false,
              priceData.error_info.data
            );
          }
          if (priceData.warnings) {
            this.warnings = priceData.warnings_list_info;
            priceData.warnings_list_info.forEach(
              function (warn) {
                this.notify("warn", warn.ID, false, warn.data);
              }.bind(this)
            );
          }

          //update prices and delays
          //+ updates informations view
          this.views.price.updatePrices(priceData);
          // staff only
          if (window.isStaff) {
            this.views.informations.updateInformations(priceData);
          }

          //update scale error to show the user what he have to do to remove the error
          this.views.settings.updateScaleError();

          this.setLoading(false);

          deferred.resolve();
        }.bind(this)
      )
      .error(function (error) {
        console.log("Update price error:", error);
      });

    return deferred;
  };

  /**
   * SvgViewer callback.
   * Display the correct tool after loading the design. Configuration is shown if the design does not
   * have been configured, otherwise we switch the user to the preview mode.
   */
  PrintController2D.prototype.onViewerInitialized = function () {
    SvgViewer.set_material(this.design.material.viewer_material);

    SvgViewer.setAllowedCutTypes(this.design.material.allowed_cut_types);

    var colorize_op = this.design.get_operation(
      "LasercutColorizeDesignOperation"
    );
    //already a configutation
    if (colorize_op && colorize_op.data.enabled) {
      //switch to review mode
      this.switchTool(sculpteo.PrintToolsView.TOOLS.REVIEW);

      //update the price
      this.updatePriceForSelectedMaterial();
    } else {
      //no configuration, we need one to proceed
      this.switchTool(sculpteo.PrintToolsView.TOOLS.CONFIGURATION);
      SvgViewer.setModified(true);
      //will call the updateConfiguration and the updatePriceForSelectedMaterial
      SvgViewer.save();
    }

    this.views.settings.enabled(true);
  };

  /**
   * SvgViewer callback.
   * Saves configuration & update its prices
   */
  PrintController2D.prototype.updateConfiguration = function (
    legend_params,
    automatic
  ) {
    var colorize_op = this.design.get_operation(
      "LasercutColorizeDesignOperation"
    );

    // Create the operation if it doesn't exists yet
    // modification always happen, it can be  lazy
    var dfd = !colorize_op
      ? this.design.add_operation({
          id: this.options.lasercut.colorize_op,
          update_data: "",
          no_lazy: 0,
        })
      : true;
    $.when(dfd).then(
      function (op) {
        colorize_op = colorize_op || op;

        // if the clean path op is either absent or disabled, checkAndFixIssue is going to apply it
        // therefore we can wait for computation, otherwise it is better to compute now
        colorize_op
          .modify({
            update_data: legend_params,
            enabled: true,
            no_lazy: this.hasCleanPath(),
          })
          .then(
            function () {
              this.checkAndFixIssues().then(
                function () {
                  //after a change of configuration
                  //we calculate the bbox and set the width and height on the design.
                  //then we update the scale settings with than value
                  var bbox = SvgViewer.getBBox();
                  design.size.x = bbox.width;
                  design.size.y = bbox.height;
                  this.views.settings.updateScale();

                  this.views.review2D.toggleIssues();

                  this.updateMaterialList().then(
                    function () {
                      this.updatePriceForSelectedMaterial();
                    }.bind(this)
                  );
                }.bind(this)
              );
            }.bind(this)
          );
      }.bind(this)
    );
  };

  PrintController2D.prototype.toggleResetModelPosition = function () {
    SvgViewer.reset_model_position();
  };

  PrintController2D.prototype.toggleZoomIn = function () {
    SvgViewer.zoom_in();
  };

  PrintController2D.prototype.toggleZoomOut = function () {
    SvgViewer.zoom_out();
  };

  /**
   * Updates order quantity
   *
   * @public
   * @param {number} quantity
   */
  PrintController2D.prototype.updateQuantity = function (quantity) {
    this.design
      .update_print_op(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        quantity
      )
      .then(
        function () {
          this.design.order.quantity = quantity;
          this.updatePriceForSelectedMaterial();
        }.bind(this)
      );
  };

  /**
   * Updates unit
   *
   * @public
   * @param {string} unit
   */
  PrintController2D.prototype.updateUnit = function (unit) {
    this.design
      .update_print_op(undefined, unit, undefined, undefined, undefined)
      .then(
        function () {
          this.updatePriceForSelectedMaterial();
          this.updateMaterialList();

          //update the label unit for the input
          this.views.review2D.updateUnit();

          SvgViewer.updateScale(
            this.design.size.scaleFactor(),
            this.design.size.x,
            this.design.size.unit,
            this.design.size.units
          );
          SvgViewer.viewChanged();
        }.bind(this)
      );
  };

  /**
   * Updates scale
   *
   * @public
   * @param {float} scale
   */
  PrintController2D.prototype.updateScale = function (scale) {
    this.design
      .update_print_op(scale, undefined, undefined, undefined, undefined)
      .then(
        function () {
          this.design.size.userScale = scale;
          this.views.settings.updateScale();
          this.updatePriceForSelectedMaterial();
          this.updateMaterialList();
          SvgViewer.updateScale(
            this.design.size.scaleFactor(),
            this.design.size.x,
            this.design.size.unit,
            this.design.size.units
          );
          SvgViewer.viewChanged();
        }.bind(this)
      );
  };

  /**
   * Updates printing material, finish and painting.
   * - Update printing operation
   * - Update material selectors
   * - Update prices and delays
   * - Update viewer (magic, i dindn't to anything to make it work)
   *
   * @param {Material} material
   * @param {string} finish
   * @param {string} painting
   */
  PrintController2D.prototype.updateMaterial = function (
    material,
    finish,
    painting
  ) {
    this.setLoading(true);

    this.design
      .update_print_op(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        material,
        finish,
        painting
      )
      .then(
        function () {
          this.design.material = material;
          this.design.finish = finish;
          this.design.painting = painting;
          this.design.order.finish = finish;
          this.design.order.painting = painting;

          try {
            window.tagCommander.sendTag(null, "print_material_change", {
              product_category: this.materials
                .getCurrentMaterialMap()
                .split(",")[0],
              product_material: material.slug,
              product_finish: finish || "",
              product_painting: painting || "",
              clic_origin: "print_new",
            });
          } catch (e) {}

          this.views.settings.updateSelectors();
          this.updatePriceForSelectedMaterial();
          SvgViewer.set_material(this.design.material.viewer_material);
          SvgViewer.setAllowedCutTypes(this.design.material.allowed_cut_types);
        }.bind(this)
      )
      .fail(
        function () {
          // Material remains the same: disable loading state
          this.setLoading(false);
        }.bind(this)
      );
  };

  /**
   * Update selected production center.
   *
   * @param {Number} productionCenter
   *
   * @todo updateSelectors
   * @todo updateMaterial if the previously selected was unavailable
   */
  PrintController2D.prototype.updateProductionCenter = function (
    productionCenter
  ) {
    this.design.order.production_center = productionCenter;
    this.currentProductionCenter = productionCenter;
    this.views.settings.updateSelectors();
    this.views.settings.materialChanged(null, 1);
    this.updateDefaultMaterialMapBasedCatalogAndCurrency();

    if (window.GoogleTagManager) {
      // send tag to TGM
      window.GoogleTagManager.sendTag({
        category: "print",
        action: "print.sidebar.catalogue.save",
        label: productionCenter,
      });
    }
  };

  /**
   * Updates used currency and re-compute prices
   *
   * @public
   * @param {string} currency - EUR, GBP, USD
   * @param {string} symbol - €, £, $
   */
  PrintController.prototype.updateCurrency = function (currency, symbol) {
    this.design.order.currency = currency;
    this.design.order.currency_symbol = symbol;
    this.materials.clearPrices();
    this.updatePriceForSelectedMaterial();
    this.updateMaterialList();

    this.updateDefaultMaterialMapBasedCatalogAndCurrency();
    if (window.GoogleTagManager) {
      // send tag to TGM
      window.GoogleTagManager.sendTag({
        category: "print",
        action: "print.currency",
        value: currency,
      });
    }
  };

  /**
   * Change enabled tool
   *
   * @param {string} tool ID
   */
  PrintController2D.prototype.switchTool = function (tool) {
    this.currentTool = tool;

    //this.views.toolbar.hideHelpTool();

    this.views.tools.setActive(this.currentTool);

    //disabled tools
    this.views.review2D.disabled();

    switch (this.currentTool) {
      case sculpteo.PrintToolsView.TOOLS.CONFIGURATION:
        SvgViewer.setLegendMode(true);
        SvgViewer.setMeasuringMode(false);

        $("#lasercut-legend-setter-widget").show();
        $("#lasercut-legend-review").hide();

        //call toggleMode to display the right help
        this.views.toolbar.toggleMode(this.currentTool);

        this.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.CONFIGURATION,
          gettext("Mode : Configuration"),
          false
        );
        break;
      case sculpteo.PrintToolsView.TOOLS.REVIEW:
        SvgViewer.setLegendMode(false);
        SvgViewer.setMeasuringMode(false);

        //call toggleMode to display the right help
        this.views.toolbar.toggleMode(this.currentTool);

        this.views.review2D.enabled();

        $("#lasercut-legend-setter-widget").hide();
        $("#lasercut-legend-review").show();

        this.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.REVIEW,
          gettext("Mode : Review"),
          false
        );
        break;
    }
  };

  //todo
  //we need to show the error when we get one
  PrintController2D.prototype.getIssues = function (show_message) {
    var dfd = $.Deferred();
    SvgViewer.setRenderLayerEnabled(false);
    SvgViewer.setIssues({});
    this.hasIssuesWithClosedPath = false;
    dfd.resolve();
    return dfd.promise();
  };

  // check for an enabled LasercutCleanPathsDesignOperation,
  PrintController2D.prototype.hasCleanPath = function () {
    var cleanpaths_op = this.design.get_operation(
      "LasercutCleanPathsDesignOperation"
    );
    if (cleanpaths_op && cleanpaths_op.data.enabled) {
      return 1;
    } else {
      return 0;
    }
  };

  PrintController2D.prototype.checkAndFixIssues = function () {
    var dfd_check = $.Deferred();
    this.getIssues().then(
      function () {
        var dfd = $.Deferred();
        var dfd_op = true;
        var cleanpaths_op = this.design.get_operation(
          "LasercutCleanPathsDesignOperation"
        );
        if (cleanpaths_op) {
          if (!cleanpaths_op.data.enabled) {
            dfd_op = cleanpaths_op.modify({ enabled: true });
          }
        } else {
          //laserCutCleanPathsDesignOperation come from index

          var args_cleanpaths = {
            id: laserCutCleanPathsDesignOperation,
          };
          dfd_op = this.design.add_operation(args_cleanpaths);
        }
        $.when(dfd_op).then(
          function (op) {
            if (SvgViewer.hasIssues()) {
              SvgViewer.load_render_model(
                this.design.model_url(),
                function () {
                  this.getIssues(true).then(function () {
                    dfd.resolve();
                  });
                }.bind(this)
              );
            } else {
              dfd.resolve();
            }
          }.bind(this)
        );
        $.when(dfd).then(function () {
          dfd_check.resolve();
        });
      }.bind(this)
    );
    return dfd_check.promise();
  };

  /**
   * Reset the following settings & updates the printing operation
   * - material, finish, painting
   * - scale & unit
   */
  PrintController2D.prototype.reset = function () {
    this.setLoading(true);

    this.overlayNotify(
      sculpteo.PrintOverlayNotification.TYPE.RESET,
      gettext("Reset 2D settings and scale"),
      false
    );

    this.design.dfd_fetch_operation = undefined;
    this.design.model_uuid = undefined;
    this.design.fetch_operation(true, false).done(
      function (response) {
        // Updating stored data
        this.design.material =
          window.materials[this.design.print_operation.data.o_product];
        this.design.finish = null;
        this.design.painting = null;
        this.design.order.finish = null;
        this.design.order.painting = null;
        this.design.size.userScale = this.design.print_operation.data.scale;
        this.design.size.unit = this.design.print_operation.data.unit;

        // Updating views
        this.views.settings.updateScale();
        this.views.settings.updateUnit();
        this.views.settings.updateSelectors();

        this.updatePriceForSelectedMaterial();

        //this.updatePriceForSelectedMaterial();
        this.updateMaterialList();

        //go to the top of the page when we reset
        this.views.viewer.scrollTop();
      }.bind(this)
    );
  };

  //generate error
  PrintController2D.prototype.onAllowedChanged = function (hasHidden) {
    if (hasHidden) {
      this.hasHiddenCut = true;
      //this.updatePriceForSelectedMaterial();
    } else {
      this.hasHiddenCut = false;
    }
  };

  //generate error like :
  //lasercut_all_ignored
  PrintController2D.prototype.onSaveLegendError = function (code) {
    if (code == "lasercut_all_ignored") {
      this.hasNoConfiguration = true;
      //this.updatePriceForSelectedMaterial();
    }
  };

  PrintController2D.prototype.onLegendChange = function () {
    this.hasNoConfiguration = false;
  };
})((window.sculpteo = window.sculpteo || {}));
